import {Injectable} from "@angular/core";
import {ApiConstant} from "@api-module/api.endpoint.constant";
import {HttpClient} from "@angular/common/http";
import {HttpParamsService} from "@api-module/service/http-params.service";
import {IResponse} from "@api-module/model/common/i-response";

@Injectable({
    providedIn: 'root'
})
export class MarginRestService {
    readonly BASE_URL: string = ApiConstant.MARGIN;
    readonly PROTECTED_BASE_URL: string = ApiConstant.PROTECTED + ApiConstant.MARGIN;

    constructor(private http: HttpClient, private paramService: HttpParamsService) {}

    findProductLtvInfo(exchangeId, symbol) {
        const dto = {symbolList: [ {
            "exchangeId": exchangeId,
            "symbol": symbol
        }]};
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.FIND_PRODUCT_LTV_INFO, dto, {});
    }

    findPreLoginProductLtvInfo(exchangeId, symbol) {
        const dto = {symbolList: [ {
            "exchangeId": exchangeId,
            "symbol": symbol
        }]};
        return this.http.post<IResponse<any>>(this.BASE_URL + ApiConstant.FIND_PRODUCT_LTV_INFO, dto, {});
    }
    
    marginInterestRate(refno: string, currency?: string) {
        const params = this.paramService.buildHttpParams({refno,currency});
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.MARGIN_INTEREST_RATE, {}, {params});
    }

    findOrderCreditBalance(dto) {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.FIND_ORDER_CREDIT_BALANCE, dto, {});
    }

    marginSummary(refno: string) {
        const params = this.paramService.buildHttpParams({refno});
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.MARGIN_SUMMARY, {}, {params});
    }

    hasOutstandingLoan(refno: string) {
        const params = this.paramService.buildHttpParams({refno});
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.HAS_OUTSTANDING_LOAN, {}, {params});
    }

    marginTrustAcctPrecheck(dtoList) {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.MARGIN_TRUST_ACCT_PRE_CHECK, dtoList, {});
    }

    marginOrderBulkPrecheck(dtoList) {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.MARGIN_ORDER_BULK_PRE_CHECK, dtoList, {});
    }

    findMarginLoanHistory(dto) {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.FIND_MARGIN_LOAN_HISTORY, dto, {});
    }

    findMarginCurrencies() {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.FIND_MARGIN_CURRENCIES, {}, {});
    }

    findMarginLoanAndRepaymentSummary(dto) {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.FIND_MARGIN_LOAN_AND_REPAYMENT_SUMMARY, dto, {});
    }

    findMarginLoanRepaymentDetails(dto) {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.FIND_MARGIN_LOAN_REPAYMENT_DETAILS, dto, {});
    }

    marginCreditBalance(refno: string) {
        const params = this.paramService.buildHttpParams({refno});
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.MARGIN_CREDIT_BALANCE, {}, {params});
    }

    findCreditSummary(dto) {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.FIND_CREDIT_SUMMARY, dto, {});
    }

    marginOptIn(dto) {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.MARGIN_OPT_IN, dto, {});
    }

    marginOptOut(dto) {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.MARGIN_OPT_OUT, dto, {});
    }

    marginPortfolio(refno,exchangeId?) {
        const params = this.paramService.buildHttpParams({refno,exchangeId});
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.MARGIN_PORTFOLIO, {}, {params});
    }

    getMarginCallAlertSetup() {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.GET_MARGIN_CALL_ALERT_SETUP, {}, {});
    }

    updateMarginCallAlertSetup(dto) {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.UPDATE_MARGIN_CALL_ALERT_SETUP, dto, {});
    }

    getMarginSystemInterestRate(){
        return this.http.post<IResponse<any>>(this.BASE_URL + ApiConstant.GET_MARGIN_SYSTEM_INTEREST_RATE, {});
    }

    getAccountRpq(refno: string) {
        const params = this.paramService.buildHttpParams({refno});
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.GET_ACCOUNT_RPQ, {}, {params});
    }
		
	findAllProductTypeLtvInfo(productType){
		const params = this.paramService.buildHttpParams({productType});
		return this.http.post<IResponse<any>>(this.BASE_URL + ApiConstant.FIND_ALL_PRODUCT_TYPE_LTV_INFO, {}, {params});
	}
	
	findDailyProductTypeLtvInfo(productType){
		const params = this.paramService.buildHttpParams({productType});
		return this.http.post<IResponse<any>>(this.BASE_URL + ApiConstant.FIND_DAILY_PRODUCT_TYPE_LTV_INFO, {}, {params});
	}

    updateMarginCreditLimit(dto) {
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.UPDATE_MARGIN_CREDIT_LIMIT, dto, {});
    }

    accountResync(refno: string) {
        const params = this.paramService.buildHttpParams({refno});
        return this.http.post<IResponse<any>>(this.PROTECTED_BASE_URL + ApiConstant.ACCOUNT_RESYNC, {}, {params});
    }
    
    findSelectedProductLtvInfo(dto: any) {
        return this.http.post<IResponse<any>>(this.BASE_URL + ApiConstant.FIND_SELECTED_PRODUCT_LTV_INFO, dto, {});
    }
}